import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { TableHead, TableRow, TableCell, TableBody } from '@mui/material';

const variantMapping = { h1: 'h1', h2: 'h2', h3: 'h3', h4: 'h4', h5: 'h5', h6: 'h6', subtitle1: 'h5', subtitle2: 'h5', body1: 'p', body2: 'p' };

const MarkdownParagraph = (props) => (
  <Typography variant="body1" sx={{ my: 1 }}>
    {props.children}
  </Typography>
);

const MarkdownHeading = (props) => {
  const children = React.Children.toArray(props.children);
  const level = props.level || Number(`${props.node?.tagName || ''}`.replace('h', ''));
  let variant;
  switch (level) {
    case 1:
      variant = 'h1';
      break;
    case 2:
      variant = 'h2';
      break;
    case 3:
      variant = 'h3';
      break;
    default:
      variant = 'h6';
      break;
  }
  const id = typeof children[0] === 'string' ? children[0].toLowerCase().replace(/[ ]/g, '-') : '';
  return (
    <Typography id={id} gutterBottom variant={variant} variantMapping={variantMapping} sx={{ mt: 2 }}>
      {children}
    </Typography>
  );
};

const MarkdownListItem = (props) => (
  <li>
    <Typography component="span">{props.children}</Typography>
  </li>
);

const MarkdownTable = (props) => (
  <TableContainer component={Paper} sx={{ overflowX: 'initial' }}>
    <Table size="small" aria-label="a dense table" stickyHeader>
      {props.children}
    </Table>
  </TableContainer>
);

const renderers = {
  h1: MarkdownHeading,
  h2: MarkdownHeading,
  h3: MarkdownHeading,
  h4: MarkdownHeading,
  h5: MarkdownHeading,
  h6: MarkdownHeading,
  p: MarkdownParagraph,
  link: Link,
  li: MarkdownListItem,
  table: MarkdownTable,
  thead: TableHead,
  tbody: TableBody,
  tr: TableRow,
  td: TableCell,
  th: TableCell,
};

export default function Markdown(props) {
  return <ReactMarkdown remarkPlugins={[remarkGfm]} escapeHtml={false} components={renderers} {...props} />;
}
